import React from 'react';
import { Check, Crown, Gem, Star, Volume2, X } from 'lucide-react';

function giftIcon(amount) {
  if (amount >= 10) return { Icon: Crown, color: 'text-[#d4a853]' };
  if (amount >= 5) return { Icon: Gem, color: 'text-[#d4a853]/70' };
  return { Icon: Star, color: 'text-white/50' };
}

export const LiveTipQueue = ({ session, lang, onModerate, busy }) => {
  const pending = session?.pending_tips || [];

  if (!pending.length) return null;

  return (
    <div data-testid="pulse-live-tip-queue" className="rounded-xl bg-[#1a1a1a] border border-[#d4a853]/15 p-3">
      <div className="flex items-center gap-2 mb-2">
        <Volume2 size={13} className="text-[#d4a853]" />
        <span className="text-[10px] uppercase tracking-widest text-[#d4a853] font-medium">
          {lang === 'es' ? 'Propinas pendientes' : 'Pending tips'}
        </span>
        <span className="text-[10px] text-white/20">{pending.length}</span>
      </div>
      <div className="space-y-2 max-h-[200px] overflow-y-auto">
        {pending.map(tip => {
          const { Icon, color } = giftIcon(tip.amount);
          return (
            <div key={tip.id} data-testid={`pulse-live-pending-tip-${tip.id}`} className="rounded-lg bg-white/4 border border-white/6 px-3 py-2 flex items-center gap-3">
              <Icon size={16} className={color} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-[11px] font-semibold text-white">{tip.user_name}</span>
                  <span className="text-[11px] text-[#d4a853]">{tip.amount}{'\u20AC'}</span>
                </div>
                {tip.message && <p className="text-[11px] text-white/40 truncate">{tip.message}</p>}
              </div>
              <div className="flex items-center gap-1 shrink-0">
                <button
                  data-testid={`pulse-live-tip-approve-${tip.id}`}
                  onClick={() => onModerate(tip.id, 'approve')}
                  disabled={busy}
                  className="w-7 h-7 rounded-full bg-emerald-500/15 border border-emerald-500/25 flex items-center justify-center text-emerald-400 hover:bg-emerald-500/25 transition disabled:opacity-30"
                >
                  <Check size={13} />
                </button>
                <button
                  data-testid={`pulse-live-tip-reject-${tip.id}`}
                  onClick={() => onModerate(tip.id, 'reject')}
                  disabled={busy}
                  className="w-7 h-7 rounded-full bg-red-500/10 border border-red-500/20 flex items-center justify-center text-red-400 hover:bg-red-500/20 transition disabled:opacity-30"
                >
                  <X size={13} />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
